import * as React from 'react';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {SaveButton} from 'shells/button/save-button/save-button';

import {addNotification} from '../../../../notifications/index';

import {useCreateSubmissionsCSV} from '../graphql/hooks/use-create-submissions-csv';

type Props = {
    formId: string;
    totalCount: number;
};

export function DownloadSubmissionsButton(props: Props) {
    const [errorSaving, setErrorSaving] = React.useState(false);
    const {createSubmissionsCSV, isLoading} = useCreateSubmissionsCSV();

    const handleCreateSubmissionsCSV = () => {
        setErrorSaving(false);

        createSubmissionsCSV({formId: props.formId})
            .then(({data}) => {
                if (data) {
                    window.open(data.submissionsCsvGenerate.url);
                }
            })
            .catch((data) => {
                setErrorSaving(true);

                const graphqlErrorMessage =
                    safelyGetGraphQLErrorMessage(data) || 'An unknown error occurred.';

                let message = graphqlErrorMessage;
                if (!message.includes('permission to export')) {
                    message = `${message} Please try again later.`;
                }

                addNotification('', {
                    body: message,
                    icon: 'frowny',
                });
            });
    };

    return (
        <SaveButton
            isSaving={isLoading}
            // @ts-expect-error
            onClick={handleCreateSubmissionsCSV}
            buttonText={props.totalCount > 1 ? 'Download submissions' : 'Download submission'}
            savingText='Downloading...'
            successText={props.totalCount > 1 ? 'Submissions downloaded' : 'Submission downloaded'}
            variant='primary'
            size='big'
            resetOnComplete={true}
            errorSaving={errorSaving}
        />
    );
}
